import { render, staticRenderFns } from "./AddTaskWatcherModal.vue?vue&type=template&id=1be67e66&scoped=true"
import script from "./AddTaskWatcherModal.vue?vue&type=script&lang=js"
export * from "./AddTaskWatcherModal.vue?vue&type=script&lang=js"
import style0 from "./AddTaskWatcherModal.vue?vue&type=style&index=0&id=1be67e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be67e66",
  null
  
)

export default component.exports